import { useRouter } from 'next/router'

import { FormattedMessage } from 'react-intl'

import QRCodeProdSrc from 'app/assets/images/get-app/qr-code-production.png'
import QRCodeStageSrc from 'app/assets/images/get-app/qr-code-staging.png'
import Box from 'app/components/base/Box'
import Button from 'app/components/base/Button'
import Image from 'app/components/base/Image'
import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'
import { CI_ENV } from 'app/utils/constants/env.constants'
import { getStaticImageSrc } from 'app/utils/helpers/functions.helpers'

export const ScanWithPhoneSection = () => {
  const { push } = useRouter()
  const isProduction = CI_ENV === 'production'

  const qrCodeImage = isProduction ? QRCodeProdSrc : QRCodeStageSrc
  const qrCodeImageSrc = getStaticImageSrc(qrCodeImage)

  return (
    <Stack
      direction={{ xs: 'column', lg: 'row' }}
      spacing={{ xs: 2, lg: 3.75 }}
      sx={{ mt: 2, alignSelf: { xs: 'center', md: 'flex-start' } }}
    >
      <Stack
        direction="column"
        spacing={1}
        sx={{
          width: 255,
          height: 250,
          py: 2,
          px: 4.5,
          background: 'linear-gradient(180deg, #F0F5FF 0%, #F6F9FE 100%)',
          borderRadius: 2,
          border: '1px solid',
          borderImageSource:
            'linear-gradient(180deg, #D6DCE9 0%, rgba(214, 220, 233, 0) 100%)'
        }}
      >
        <Text variant="h3" component="p" sx={{ fontWeight: 500 }}>
          <FormattedMessage defaultMessage="Scan with Phone" />
        </Text>

        <Box>
          <Image
            src={qrCodeImageSrc}
            alt="qr-code"
            width={182}
            height={182}
            sizes="256px"
            placeholder="blur"
          />
        </Box>
      </Stack>

      <Stack
        direction="column"
        spacing={2}
        sx={{ mt: '16px !important', width: 255 }}
      >
        <Text
          variant="h3"
          component="p"
          sx={{ fontWeight: 500, textAlign: 'center' }}
        >
          <FormattedMessage defaultMessage="Or Continue with Web" />
        </Text>

        <Button variant="outlined" onClick={() => push('/')}>
          <FormattedMessage defaultMessage="Go to Homepage" />
        </Button>
      </Stack>
    </Stack>
  )
}
